<template>
  <div v-cloak class="v-cloak--invisible">
    <!-- Header -->
    <section-header
      size="md"
      variants="dividing"
      qaid="sku-grid.bulk-order"
      class="section-header--non-stacking mt-5 xl:mt-0"
    >
      <template v-if="!isPdp" slot="content">
        <heading :level="2" size="md">
          {{ bp('bulk') }}
        </heading>
      </template>
      <template slot="actions">
        <div class="flex items-center text-sm font-medium" qaid="sku-grid.unavailable">
          {{ bp('inStock') }}
          <grid-switch class="ml-1" :data="{id: 'show-unavailable'}" @switch-change="hideUnavailable = $event">
          </grid-switch>
        </div>
      </template>
    </section-header>

    <!-- Product Groups wrapper/iterator -->
    <div class="b2b-grid-group">
      <div
        v-for="(productGroup, productGroupIndex) in productGroups"
        :key="productGroupIndex"
        class="b2b-grid-group__section"
        :product-group-index="productGroupIndex"
      >
        <pdl-collapse
          icon-active="indeterminate_check_box"
          icon-inactive="add_box"
          icon-position="left"
          align-icon="start"
          :default-active="false"
          :value="viewBreakpointMoreThan('medium') ? [productGroupIndex] : null"
          qaid="bulk-product-collapse"
        >
          <bulk-product-grid
            :hide-unavailable="hideUnavailable"
            :base-properties="baseProperties"
            :image-size="{width: 192, height: 144}"
            image-format="pjpeg"
            image-quality="60,1"
            image-unsharp-mask
            :base-product="baseProductCode"
            :product-group="productGroup"
            :product-type="productGroup.productType"
            :product-group-index="productGroupIndex"
            :apple-table-headers="appleTableHeaders"
            :is-pdp="isPdp"
            :product-groups="productGroups"
            @add-to-cart="handleAddToCart"
            @update-stock-watch-state="(payload) => $emit('update-stock-watch-state', payload)"
            @update-cart-or-list-column="updateColumns"
          />
        </pdl-collapse>
      </div>
    </div>

    <bundling-dialog
      :base-properties="baseProperties"
      :apple-table-headers="appleTableHeaders"
      :show-dialog="isBundleDialogVisible"
      :add-to-cart-button-caption="bp('addToCart')"
      @cancel="setBundleDialogVisibility({type: 'GRID', isVisible: false})"
      @add-to-cart="setBundleDialogVisibility({type: 'GRID', isVisible: false})"
    />
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import viewSize from '@/mixins/view-size';
import GridSwitch from '@/components/grid/GridSwitch';
import {PdlCollapse} from '@pedal/pdl-collapse';
import BulkProductGrid from '@/components/containers/bulk-product/BulkProductGrid';
import BundlingDialog from '@/components/containers/pdp/BundlingDialog';
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';

export default {
  components: {
    GridSwitch,
    PdlCollapse,
    BulkProductGrid,
    BundlingDialog,
    SectionHeader,
    Heading,
  },

  mixins: [viewSize],

  props: {
    appleTableHeaders: {
      type: Array,
      default: () => [],
    },
    productGroups: {
      type: Array,
      default: () => [],
    },
    isPdp: Boolean,
  },

  data() {
    return {
      hideUnavailable: false,
    };
  },

  computed: {
    baseProductCode() {
      return !this.productGroups || !('code' in this.productGroups) ? '' : this.productGroups.code;
    },

    isBundleDialogVisible: {
      get() {
        return this.isGridBundleDialogVisible;
      },

      set(isVisible) {
        this.setBundleDialogVisibility({type: 'GRID', isVisible});
      },
    },

    ...mapState('skuGrid', ['baseProductsSkus']),
    ...mapState('pdp', ['isGridBundleDialogVisible']),
    ...mapState('productBundle', ['bundleTemplateIds']),
  },

  methods: {
    updateColumns(responseData) {
      const responseEntries = responseData.response;
      const colName = responseData.colName;
      this.productGroups.forEach((productGroup) => {
        const products = productGroup.products;
        this.$store.dispatch('skuGrid/updateCartOrListColumn', {products, responseEntries, colName}).then((res) => {
          productGroup.products = res;
        });
      });
    },

    handleAddToCart() {
      let bundleIds = [];

      //   Get the respective bundletemplateId, if present, open up the bundle modal.
      this.baseProductsSkus.forEach((code) => {
        let id = this.bundleTemplateIds.find((id) => id.includes(code));
        id && bundleIds.push(id);
        this.setActiveIds(bundleIds);
      });

      if (bundleIds.length > 0) this.setBundleDialogVisibility({type: 'GRID', isVisible: true});
    },

    ...mapMutations('productBundle', ['setActiveIds']),
    ...mapMutations('pdp', ['setBundleDialogVisibility']),
  },
};
</script>
